export const fetchCardHistoricoAtosAction = () => ({ type: 'FETCH_CARD_HISTORICO_ATOS' });
export const fetchCardHistoricoAtosActionSuccess = data => ({ type: 'FETCH_CARD_HISTORICO_ATOS_SUCCESS', data });
export const fetchCardHistoricoAtosActionError = error => ({ type: 'FETCH_CARD_HISTORICO_ATOS_ERROR', error });
export const fetchCardPageHistoricoAtosAction = data => ({ type: 'FETCH_CARD_PAGE_HISTORICO_ATOS', data });
